import React from 'react'
import ProfileTable from './ProfileTable'
import BasicLayout from 'components/BasicLayout'

function ProfileSection() {

  const SampleComponent = BasicLayout(ProfileTable)
  return (
    <SampleComponent />
  )
}

export default ProfileSection